import {
  STATUSES,
  CREATE_ROUTE_DATA,
  FILTER_CHIPS,
  RESPONSE_CONSTANTS,
  ROUTE_STATUSES,
  TERMINAL_STATUSES,
  NON_EDITABLE_STATUSES,
  CANCELLED,
  DEFAULT_FILTER_CHIP,
  COMPLETED,
  REPLANNING_CONSIGNMENT_SUCCESS_MSG,
  DEFAULT_FILTER_OBJECT_ROUTE,
  DEFAULT_FILTERS_OBJ_CONSIGNMENT,
  SEARCH_TYPES,
  SORT_MODAL,
} from "./StandardSharedConstants";
import { createAutocompleteFilter } from "./FilterUtils";

const DeliveryConstants = {
  CONSIGNMENTS_DATA: {
    TABLE_WRAPPER_DATA: {
      title: "Orders",
      HeaderData: [
        {
          field: "id",
          headerName: "Id",
          hide: true,
        },
        {
          field: "hubCode",
          headerName: "Hub Code",
          width: 150,
          filter: true,
          filterObj: createAutocompleteFilter(
            "hubCode",
            "hub",
            "c.posInformation.store",
            "Hub Code"
          ),
        },
        {
          field: "hubName",
          headerName: "Hub Name",
          width: 200,
          filter: true,
          filterObj: createAutocompleteFilter(
            "hubName",
            "hubName",
            "c.posInformation.store",
            "Hub Name"
          ),
        },
        {
          field: "consignmentId",
          headerName: "Consignment ID",
          width: 150,
        },
        {
          field: "deliveryArea",
          headerName: "Area",
          width: 200,
          filter: true,
          filterObj: createAutocompleteFilter(
            "deliveryArea",
            "deliveryArea",
            "c.deliveryInformation.customerContactInfo.address.area",
            "Delivery Area"
          ),
        },
        {
          field: "type",
          headerName: "Type",
          width: 120,
          filter: true,
          filterObj: createAutocompleteFilter(
            "type",
            "orderType",
            "c.metadata.category",
            "Order Type"
          ),
        },
        {
          type: "date",
          field: "deliveryDate",
          headerName: "Delivery Date",
          width: 160,
          filter: true,
          filterObj: {
            type: "dateRange",
            fieldKey: "deliveryDate",
            fieldName: "dateRange",
            key: `dateRange-filter`,
            placeholderText: "Delivery Date",
            label: "Delivery Date",
            autoUpdateInput: false,
            autoApply: true,
            showDropdowns: true,
            linkedCalendars: true,
            maxSpan: {
              month: "1",
            },
            locale: {},
          },
        },
        {
          field: "startEndTime",
          headerName: "Delivery Slot",
          width: 150,
          filter: true,
          filterObj: {
            type: "autocomplete",
            fieldName: "deliverySlot",
            multiple: true,
            key: `autoComplete-deliverySlot`,
            label: "Delivery Slot",
            items: [],
            fieldKey: "startEndTime",
          },
        },
        {
          field: "deliveryStatus",
          headerName: "Status",
          width: 170,
          filter: true,
          filterObj: {
            type: "autocomplete",
            fieldKey: "deliveryStatus",
            fieldName: "deliveryStatus",
            fieldFullName: "c.metadata.deliveryStatus",
            multiple: true,
            key: `autoComplete-delStatus`,
            label: "Delivery Status",
            items: [],
          },
        },
        {
          field: "statusDate",
          headerName: "Last Updated",
          width: 160,
        },
        {
          field: "numberOfItems",
          headerName: "No. of Items",
          width: 130,
        },
        {
          field: "orderId",
          headerName: "Order ID",
          width: 130,
        },
        {
          field: "transactionDate",
          headerName: "Order Creation Date",
          width: 180,
        },
        {
          field: "customerName",
          headerName: "Customer Name",
          width: 150,
        },
        {
          field: "customerEmail",
          headerName: "Customer Email",
          width: 150,
        },
        {
          field: "customerMobileNumber",
          headerName: "Customer Mobile",
          width: 160,
        },
        {
          field: "deliveryStreetAddress",
          headerName: "Delivery Street Address",
          width: 200,
        },
        {
          field: "landmark",
          headerName: "Landmark",
          width: 200,
        },
        {
          field: "paymentType",
          headerName: "Payment Type",
          width: 160,
          filter: true,
          filterObj: createAutocompleteFilter(
            "paymentType",
            "paymentType",
            "c.metadata.paymentType",
            "Payment Type"
          ),
        },
        {
          field: "totalAmount",
          headerName: "Total Amount",
          width: 140,
        },
        {
          field: "codAmount",
          headerName: "COD Amount",
          width: 130,
        },
        {
          field: "collectedAmount",
          headerName: "Collected Amount",
          width: 160,
        },
        {
          field: "carrier",
          headerName: "Carrier",
          width: 120,
          filter: true,
          filterObj: createAutocompleteFilter(
            "carrier",
            "carrier",
            "c.deliveryInformation.carrier",
            "Carrier"
          ),
        },
        {
          field: "deliveryProposition",
          headerName: "Delivery Proposition",
          width: 200,
          filter: true,
          filterObj: createAutocompleteFilter(
            "deliveryProposition",
            "deliveryProposition",
            "c.metadata.deliveryType",
            "Delivery Proposition"
          ),
        },
        {
          field: "routeId",
          headerName: "Route ID",
          width: 130,
          filter: true,
          filterObj: createAutocompleteFilter(
            "routeId",
            "routeId",
            "c.metadata.routeName",
            "Route ID"
          ),
        },
        {
          field: "routeStatus",
          headerName: "Route Status",
          width: 150,
          filter: true,
          filterObj: createAutocompleteFilter(
            "routeStatus",
            "routeStatus",
            "c.metadata.routeStatus",
            "Route Status"
          ),
        },
        {
          field: "driver",
          headerName: "Driver",
          width: 150,
          filter: true,
          filterObj: createAutocompleteFilter(
            "driver",
            "driver",
            "c.deliveryInformation.driver.id",
            "Driver"
          ),
        },
        {
          field: "vehicle",
          headerName: "Vehicle",
          width: 180,
          filter: true,
          filterObj: createAutocompleteFilter(
            "vehicle",
            "vehicle",
            "c.deliveryInformation.vehicle.id",
            "Vehicle"
          ),
        },
        {
          field: "helper",
          headerName: "Helper",
          width: 150,
          filter: true,
          filterObj: createAutocompleteFilter(
            "helper",
            "helper",
            "c.deliveryInformation.helper.id",
            "Helper"
          ),
        },
        {
          field: "plannedDuration",
          headerName: "Planned Duration (in mins)",
          width: 220,
        },
        {
          field: "actualDuration",
          headerName: "Actual Duration (in mins)",
          width: 210,
        },
        {
          field: "deliveryFailedReason",
          headerName: "Undelivered Reason",
          width: 200,
          filter: true,
          filterObj: createAutocompleteFilter(
            "deliveryFailedReason",
            "deliveryFailedReason",
            "c.reason.reasonCode",
            "Delivery Failed Reason"
          ),
        },
      ],
      headerButtons: [
        {
          name: "createRoute",
          displayName: "Create Route",
          disabled: false,
          hide: false,
          classes: "primary",
        },
        {
          name: "colsettings",
          displayName: "Column Settings",
          disabled: false,
          childElements: [
            {
              name: "excel",
              displayName: "Export Data",
              disabled: false,
            },
          ],
        },
      ],
      loadMore: {
        name: "loadMore",
        disabled: false,
        pageSize: 20,
      },
      defaultFiltersObj: DEFAULT_FILTERS_OBJ_CONSIGNMENT,
      SEARCH_TYPES,
      sortModel: {
        field: "deliveryDate",
        direction: "asc",
      },
    },
    FILTER_CHIPS,
    STATUSES,
    TERMINAL_STATUSES,
    NON_EDITABLE_STATUSES,
    CANCELLED,
    DEFAULT_FILTER_CHIP,
    COMPLETED,
    REPLANNING_CONSIGNMENT_SUCCESS_MSG,
    ADDRESS_UPDATE_SUCCESS_MSG: "Customer Address Updated Successfully.",
    UNPLAN_CONSIGNMENT_WARNING_MSG:
      "Please unplan the consignment first than edit the address.",
    DEFAULT_REPLANNING_SELECTION: "RESCHEDULED",
    UNDELIVERED: "UNDELIVERED",
    DELIVERED: "DELIVERED",
    COD_TEXT: "COD",
    DISPLAY_ROUTE_STATUS_FILTER_OBJ: {
      key: "displayRouteStatus",
      value: ["UNPLANNED"],
      fieldName: "c.metadata.displayRouteStatus",
    },
    DELIVERY_SLOT: [
      {
        name: "08:00-20:00",
        value: "08:00:00-20:00:00",
      },
    ],
  },
  ROUTES_DATA: {
    TABLE_WRAPPER_DATA: {
      title: "Routes",
      HeaderData: [
        {
          field: "id",
          headerName: "Id",
          hide: true,
        },
        {
          field: "hubCode",
          headerName: "Hub Code",
          width: 150,
          filter: true,
          filterObj: {
            type: "autocomplete",
            fieldKey: "hubCode",
            fieldName: "hub",
            fieldFullName: "c.hubCode",
            multiple: true,
            key: `autoComplete-hub`,
            label: "Hub Code",
            items: [],
          },
        },
        {
          field: "hubName",
          headerName: "Hub Name",
          width: 150,
          filter: true,
          filterObj: {
            type: "autocomplete",
            fieldKey: "hubName",
            fieldName: "hubName",
            fieldFullName: "c.hubCode",
            multiple: true,
            key: `autoComplete-hubName`,
            label: "Hub Name",
            items: [],
          },
        },
        {
          field: "routeId",
          headerName: "Route ID",
          width: 130,
          filter: true,
          filterObj: {
            type: "autocomplete",
            fieldKey: "routeId",
            fieldName: "routeId",
            fieldFullName: "c.routeId",
            multiple: true,
            key: `autoComplete-routeId`,
            label: "Route ID",
            items: [],
          },
        },
        {
          field: "deliveryArea",
          headerName: "Area",
          width: 150,
          filter: true,
          filterObj: {
            type: "autocomplete",
            fieldKey: "deliveryArea",
            fieldName: "deliveryArea",
            fieldFullName: "c.deliveryArea",
            multiple: true,
            key: `autoComplete-deliveryArea`,
            label: "Delivery Area",
            items: [],
          },
        },
        {
          type: "date",
          field: "deliveryDate",
          headerName: "Delivery Date",
          width: 160,
          filter: true,
          filterObj: {
            type: "dateRange",
            fieldKey: "deliveryDate",
            fieldName: "dateRange",
            key: `dateRange-filter`,
            placeholderText: "Delivery Date",
            label: "Delivery Date",
            autoUpdateInput: false,
            autoApply: true,
            showDropdowns: true,
            linkedCalendars: true,
            maxSpan: {
              month: "1",
            },
            locale: {},
          },
        },
        {
          field: "deliverySlot",
          headerName: "Delivery Slot",
          width: 150,
          filter: true,
          filterObj: {
            type: "autocomplete",
            fieldName: "deliverySlot",
            multiple: true,
            key: `autoComplete-deliverySlot`,
            label: "Delivery Slot",
            items: [],
            fieldKey: "deliverySlot",
          },
        },
        {
          field: "consignments",
          headerName: "Consignments",
          width: 110,
        },
        {
          field: "carrier",
          headerName: "Carrier",
          width: 120,
          filter: true,
          filterObj: {
            type: "autocomplete",
            fieldKey: "carrier",
            fieldName: "carrier",
            fieldFullName: "c.carrier",
            multiple: true,
            key: `autoComplete-carrier`,
            label: "Carrier",
            items: [],
          },
        },
        {
          field: "deliveryProposition",
          headerName: "Delivery Proposition",
          width: 200,
          filter: true,
          filterObj: {
            type: "autocomplete",
            fieldKey: "deliveryProposition",
            fieldName: "deliveryProposition",
            fieldFullName: "c.deliveryProposition",
            multiple: true,
            key: `autoComplete-deliveryProposition`,
            label: "Delivery Proposition",
            items: [],
          },
        },
        {
          field: "routeStatus",
          headerName: "Route Status",
          width: 150,
          filter: true,
          filterObj: {
            type: "autocomplete",
            fieldKey: "routeStatus",
            fieldName: "routeStatus",
            fieldFullName: "c.status",
            multiple: true,
            key: `autoComplete-routeStatus`,
            label: "Route Status",
            items: [],
          },
        },
        {
          field: "driver",
          headerName: "Driver",
          width: 150,
          filter: true,
          filterObj: {
            type: "autocomplete",
            fieldKey: "driver",
            fieldName: "driver",
            fieldFullName: "c.assignee.id",
            multiple: true,
            key: `autoComplete-driver`,
            label: "Driver",
            items: [],
          },
        },
        {
          field: "vehicle",
          headerName: "Vehicle",
          width: 180,
          filter: true,
          filterObj: {
            type: "autocomplete",
            fieldKey: "vehicle",
            fieldName: "vehicle",
            fieldFullName: "c.assignedVehicle.id",
            multiple: true,
            key: `autoComplete-vehicle`,
            label: "Vehicle",
            items: [],
          },
        },
        {
          field: "helper",
          headerName: "Helper",
          width: 150,
          filter: true,
          filterObj: {
            type: "autocomplete",
            fieldKey: "helper",
            fieldName: "helper",
            fieldFullName: "c.helper.id",
            multiple: true,
            key: `autoComplete-helper`,
            label: "Helper",
            items: [],
          },
        },
        {
          field: "createdBy",
          headerName: "Created By",
          width: 220,
          filter: true,
          filterObj: {
            type: "autocomplete",
            fieldKey: "createdBy",
            fieldName: "createdBy",
            fieldFullName: "c.createdBy",
            multiple: true,
            key: `autoComplete-createdBy`,
            label: "Created By",
            items: [],
          },
        },
        {
          field: "plannedDuration",
          headerName: "Planned Duration",
          width: 180,
        },
        {
          field: "actualDuration",
          headerName: "Actual Duration",
          width: 180,
        },
        {
          field: "actions",
          headerName: "Actions",
          width: 100,
        },
      ],
      headerButtons: [
        {
          name: "publish",
          displayName: "Publish Routes",
          disabled: false,
          hide: false,
          classes: "primary",
        },
        {
          name: "colsettings",
          displayName: "Column Settings",
          disabled: false,
          childElements: [
            {
              name: "excel",
              displayName: "Export Data",
              disabled: false,
            },
          ],
        },
      ],
      loadMore: {
        name: "loadMore",
        disabled: false,
        pageSize: 20,
      },
      defaultFiltersObj: DEFAULT_FILTER_OBJECT_ROUTE,
      SEARCH_TYPES: [
        {
          name: "Route Id",
          value: "c.routeId",
        },
      ],
      sortModel: SORT_MODAL
    },
    FILTER_CHIPS,
    STATUSES: ROUTE_STATUSES,
    DEFAULT_FILTER_CHIP: "PLANNED",
    UNEDITABLE_CHIP: "COMPLETED",
    PUBLISH_ROUTES_SUCCESS_MSG: "have been published successfully.",
    UPDATE_ROUTE_SUCCESS_MSG: "has been updated.",
    DELETE_ROUTE_SUCCESS_MSG: "has been deleted!",
    PUBLISH_ROUTES_ERROR_MSG: "could not be published",
    TAB_VALUES: {
      VALET_TROLLEY: "valetTrolley",
      ROUTES: "routes",
    },
    DISPLAY_ROUTE_STATUS_FILTER_OBJ: {
      key: "displayRouteStatus",
      value: ["PLANNED"],
      fieldName: "c.displayRouteStatus",
    },
  },
  VALIDATIONS: {
    AREA: {
      REQUIRED: {
        msg: "Area is required",
      },
    },
    CITY: {
      REQUIRED: {
        msg: "City is required",
      },
    },
    STREETNO: {
      REQUIRED: {
        msg: "Street Name/No is required",
      },
    },
    BUILDING: {
      REQUIRED: {
        msg: "Building Name/Villa No. is required",
      },
    },
    APARTMENT: {
      REQUIRED: {
        msg: "Apartment No. is required",
      },
    },
    PHONE: {
      REQUIRED: {
        msg: "Phone Number is required",
      },
      VALIDITY: {
        msg: "Please enter a valid Phone number",
        value:
          "^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$",
      },
    },
  },
  CREATE_ROUTE_DATA,
  RESPONSE_CONSTANTS,
  ALL_FILTER_CHIP: "ALL",
  REPORT_URL:{
    STD_LOGS:'/fulfilment/v2/export/logs',
    STD_ORDERS:'/fulfilment/v2/export/orders',
    EXPRESS_LOGS:'/fulfilment/v2/export/exp-logs',
    EXPRESS_ORDERS:'/fulfilment/v2/export/express/orders',
    USER:'fulfilment/v2/export/users',
    DRIVERS:'/fulfilment/v2/export/drivers'
  }
};

export default DeliveryConstants;
